import {AsyncPipe} from '@angular/common';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatDivider} from '@angular/material/divider';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ClientService} from '@app/admin/client.service';
import {InvitationService} from '@app/invitation/invitation.service';
import {InvitesComponent} from '@app/invitation/invites/invites.component';
import {SiteConfig, SiteConfigService} from '@app/shared/site-config.service';
import {Observable} from 'rxjs';
import {mergeMap, tap} from 'rxjs/operators';

@Component({
    selector: 'frog-invite-dialog',
    templateUrl: './invite-dialog.component.html',
    styleUrls: ['./invite-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDivider,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
        InvitesComponent,
    ],
})
export class InviteDialogComponent implements OnInit {
    @ViewChild(InvitesComponent) invitationForm;

    public siteConfig$: Observable<SiteConfig>;

    constructor(
        private siteConfigService: SiteConfigService,
        private clientService: ClientService,
        private invitationService: InvitationService,
        private matSnackBar: MatSnackBar,
        public dialogRef: MatDialogRef<InviteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string,
    ) {}

    ngOnInit(): void {
        this.siteConfig$ = this.siteConfigService.siteConfig;
    }

    send() {
        this.invitationService
            .invite(this.data, this.invitationForm.getInvitations())
            .pipe(
                tap((response) => {
                    if (response.errors.length > 0) {
                        const message = response.errors.join('<br />');
                        this.matSnackBar.open(message, 'Ok', {
                            verticalPosition: 'top',
                            panelClass: 'error-snackbar',
                        });
                    }
                }),
                mergeMap(() => this.clientService.get()),
            )
            .subscribe(() => {
                this.dialogRef.close();
            });
    }
}
